import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt } from "@fortawesome/free-solid-svg-icons";
import { getRequest } from "services/api/apiService";
import { fmtCredits, yieldLabel } from "utils/credits";

// Solde de crédits TOUJOURS visible (monté dans la sidebar + topbar mobile).
// Se rafraîchit seul, et réagit à l'événement global "credits:changed" émis
// après une génération, pour décrémenter sans recharger la page.
const CreditBalancePill = ({ compact = false }) => {
  const [balance, setBalance] = useState(null);

  const load = useCallback(() => {
    getRequest("/api/pricing/me")
      .then((r) => setBalance(Number(r?.credits ?? 0)))
      .catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const onChange = (e) => {
      if (e?.detail?.balance != null) setBalance(Number(e.detail.balance));
      else load();
    };
    window.addEventListener("credits:changed", onChange);
    const iv = setInterval(load, 60000);
    return () => { window.removeEventListener("credits:changed", onChange); clearInterval(iv); };
  }, [load]);

  const low = balance != null && balance < 1;

  return (
    <Link
      to="/dashboard/credits"
      title={balance != null ? yieldLabel(balance) : "Crédits"}
      className={`flex items-center justify-center gap-2 rounded-full font-bold transition ${
        compact ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm w-full"
      } ${low ? "bg-amber-50 text-amber-700 hover:bg-amber-100" : "bg-indigo-50 text-indigo-700 hover:bg-indigo-100"}`}
    >
      <FontAwesomeIcon icon={faBolt} className="text-xs" />
      <span className="tabular-nums">{balance == null ? "…" : fmtCredits(balance)} crédits</span>
      {low && <span className="text-[10px] font-bold underline">Recharger</span>}
    </Link>
  );
};

// Aide globale : à appeler après une génération pour mettre à jour le solde partout.
export const emitCreditsChanged = (balance) =>
  window.dispatchEvent(new CustomEvent("credits:changed", { detail: { balance } }));

export default CreditBalancePill;
